/**
 * Clears all localStorage items
 *
 * @param whitelist - any items with this key (and our prefix) will be kept
 */

const calloutWhitelist = [
  'hidePageMessage-profile-notifications',
  'hidePageMessage-client-notifications',
  'hidePageMessage-company-settings',
  'hidePageMessage-account-branding',
  'hidePageMessage-settings-quote-settings',
  'hidePageMessage-settings-quote-types',
  'hidePageMessage-settings-estimate-disclaimers',
  'hidePageMessage-settings-quote-templates',
  'hidePageMessage-estimate-tags',
  'hidePageMessage-invoice-settings',
  'hidePageMessage-settings-rates',
  'hidePageMessage-area-names',
  'hidePageMessage-settings-products',
  'hidePageMessage-settings-line-items',
  'hidePageMessage-settings-terms',
  'hidePageMessage-settings-presentations',
  'hidePageMessage-communications-email-templates',
  'hidePageMessage-communications-email-automations',
  'hidePageMessage-settings-follow-ups',
  'hidePageMessage-profile-follow-ups',
  'hidePageMessage-profile-chat',
  'hidePageMessage-settings-sources',
  'hidePageMessage-settings-team',
  // persist table column preferences across logouts
  'dealTableColumns',
  'quoteTableColumns',
  'taskTableColumns'
]

export function clearLocalStorage(options: { whitelist?: string[]; whiteListPartialMatch?: string[] } = {}) {
  const { whitelist = [], whiteListPartialMatch = [] } = options
  const localStorageKeys = Object.keys(window.localStorage)

  const entireWhitelist = ['lastLogin', 'authRedirectUrl', ...whitelist, ...calloutWhitelist]

  localStorageKeys.forEach((key) => {
    if (entireWhitelist.indexOf(key) === -1 && !whiteListPartialMatch.some((partial) => key.includes(partial))) {
      window.localStorage.removeItem(key)
    }
  })
}
